/* eslint-disable @typescript-eslint/no-explicit-any */
import { getAIChatStream } from "@/services/rest/ai-chat";
import { useMutation } from "@tanstack/react-query";

export function useAIChat(refetchCount: () => void) {
  return useMutation({
    mutationFn: async ({
      input,
      isLogin,
      userId,
      sessionId,
      onChunk,
    }: {
      input: string;
      isLogin: boolean;
      userId: string;
      sessionId: string;
      onChunk: (content: string, meta?: any) => void;
    }) => {
      await getAIChatStream(input, isLogin, userId, sessionId, onChunk);
    },
    onSettled: () => {
      refetchCount();
    },
  });
}
